"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailLocationCard = void 0;
const React = require("react");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const RetailLocationCardHeader_1 = require("./RetailLocationCardHeader");
const RetailLocationCardBody_1 = require("./RetailLocationCardBody");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "RetailLocationCard");
const RetailLocationCard = ({ retailLocation, onClick, orderType, children, showInfo, showDetails = true }) => {
    const { setRetailLocation } = (0, useRequiredContext_1.useRequiredContext)(RetailLocationsContext_1.RetailLocationsContext);
    return (React.createElement("div", { className: css("", { [`-clickable`]: typeof onClick === "function" }), onClick: typeof onClick === "function" ? onClick : null, onMouseEnter: () => setRetailLocation(retailLocation), id: `restaurant-card-${retailLocation.retailLocationId}` },
        children,
        React.createElement(RetailLocationCardHeader_1.RetailLocationCardHeader, { retailLocation: retailLocation, orderType: orderType, showDetails: showDetails }),
        React.createElement(RetailLocationCardBody_1.RetailLocationCardBody, { retailLocation: retailLocation, orderType: orderType, showInfo: showInfo })));
};
exports.RetailLocationCard = RetailLocationCard;
//# sourceMappingURL=index.js.map